import $ from 'jquery';
import 'slick-carousel';
import { loadSVG } from '../../utils/load-svg';

const sliderDienstenPosts = () => {
	const el = {
		target: '.mi-carousel__diensten .elementor-loop-container',
	};

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;

			exec();
		});
	};

	const exec = () => {
		const $target = $(el.target);
		const $style = $target.find('style[id]');

		$style.prependTo($target.parent());

		$target.on('init reInit breakpoint', function (e, slick) {
			console.log(slick.$nextArrow);
			console.log(slick.$prevArrow);

			loadSVG('/wp-content/uploads/2025/11/ic-arrow-right.svg')
				.then((svgString) => {
					slick.$nextArrow.html(svgString);
				})
				.catch(console.error);
			loadSVG('/wp-content/uploads/2025/11/ic-arrow-left.svg')
				.then((svgString) => {
					slick.$prevArrow.html(svgString);
				})
				.catch(console.error);
		});

		$target.slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			draggable: true,
			adaptiveHeight: false,
			infinite: false,
			autoplay: false,
			speed: 500,
			nextArrow: '<button class="slick-arrow slick-next"></button>',
			prevArrow: '<button class="slick-arrow slick-prev"></button>',
			responsive: [
				{
					breakpoint: 1180,
					settings: {
						slidesToShow: 3.25,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 896,
					settings: {
						slidesToShow: 2.25,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1.25,
						slidesToScroll: 1,
					},
				},
			],
		});
	};

	init();
};

try {
	sliderDienstenPosts();
} catch (error) {
	console.error(error);
}
